import React from 'react';

import SearchInput, { SearchInputProps } from 'Elements/Input/Search';

import Grid, { Col } from 'Components/Grid';

import { Container, Heading } from './Search.styled';

export interface Props {
    heading: string;
    search: SearchInputProps;
}

const Search: React.FC<Props> = props => {
    const { heading, search } = props;

    return (
        <Container>
            <Grid>
                <Col>
                    <Heading>{heading}</Heading>
                    <SearchInput {...search} />
                </Col>
            </Grid>
        </Container>
    );
};

export default Search;
